import { render, staticRenderFns } from "./addNedit-brand.vue?vue&type=template&id=c21c5d2c&scoped=true&"
import script from "./addNedit-brand.vue?vue&type=script&lang=js&"
export * from "./addNedit-brand.vue?vue&type=script&lang=js&"
import style0 from "./addNedit-brand.vue?vue&type=style&index=0&id=c21c5d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c5d2c",
  null
  
)

export default component.exports